module.exports = __webpack_public_path__ + "static/images/styles/images/events/event-upgrade.164c5a3a.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/events/event-upgrade.png
// module id = 3626
// module chunks = 11